// extracted by mini-css-extract-plugin
module.exports =  {"link":"link--ia3Ow"};